import { a as D } from "../add-DH4DZT_w.mjs";
import { f as d } from "../format-DF9p-6BI.mjs";
import { determineSeasonNumber as S, determineEpisodeNumber as m, determineSeasonNumberFromSeriesPrefix as g } from "../utils/series-helpers.js";
import { convert12to24 as b } from "../utils/helpers.js";
import { determineIfShowIsOnNow as O } from "../utils/date-helpers.js";
import { g as v } from "../index-0wieGV50.mjs";
const I = async ({
  dateStr: n,
  schedEndpoint: h,
  network: _ = null,
  showEpisodeNumber: u = !1,
  showUpcoming: $ = !1
}) => {
  const c = v("America/New_York", new Date(n)) / 36e5, p = d(/* @__PURE__ */ new Date(`${n}T00:00:00`), "yyyy-MM-dd"), i = d(new Date(D(/* @__PURE__ */ new Date(`${n}T00:00:00`), { days: 1 })), "yyyy-MM-dd"), w = (s) => {
    const e = /* @__PURE__ */ new Date(`${n}T06:00:00-0${c * -1}:00`), r = /* @__PURE__ */ new Date(`${i}T06:00:00-0${c * -1}:00`);
    return s.filter((f) => {
      const o = f.start_ts_parse * 1e3;
      return o >= e.valueOf() && o < r.valueOf();
    });
  }, T = async () => {
    let s = [], e = {}, r = 0, l = "";
    const f = p, o = i;
    do {
      l = `${h}/${_}?ordering=start_ts_parse&start_date__range=${f},${o}&limit=100&offset=${r}`;
      try {
        const t = await fetch(l);
        if (t != null && t.ok)
          e = await t.json(), s = [...s, ...e.results];
        else {
          console.error(`An error was returned from fetch. HTTP Response Code: ', ${t == null ? void 0 : t.status}`);
          break;
        }
      } catch (t) {
        console.error("Fetch failed with error:", t);
        break;
      }
      r += 100;
    } while (e.next !== null);
    return s.length === 0 ? void 0 : w(s).map((t) => ({
      ...t,
      showUpcoming: $
    }));
  }, y = (s) => s.filter((e) => {
    if (e.series_prefix === null && e.title_code === null) return !1;
    const r = /* @__PURE__ */ new Date();
    return !!(e.start_ts_parse * 1e3 > r.valueOf() || O(`${e.start_date_parse}T${b(e.start_time)}`, e.element_length));
  }).map((e) => {
    let r = "";
    return e.series_prefix === null ? r = u ? `${S(e)}${m(e)}` : "" : r = u ? `${g(e)}${m(e)}` : "", {
      ...e,
      episode_number: r
    };
  }), a = await T();
  return a === void 0 || a.length === 0 ? [{ queryStatus: "no-results" }] : y(a);
};
export {
  I as default
};
